import React, { Suspense, useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import NotFound from "components/NotFound";
import { Route, Switch, withRouter } from "react-router-dom";
import Settings from "components/Settings";
import Customers from "components/Management/Customers";
import Visitors from "components/Management/Visitors";
import LoadingPage from "components/common_components/LoadingPage";
import SecureRoute from "components/SecureRoute";
import NotAuthorized from "components/NotAuthorized";
import Menu from "components/Menu";
import Module from "components/Modules/Module";
import AppContext from "AppContext";
import HomePage from "./Home";
import Calendar from "components/Calendar";
import ChatPage from "components/Chat/Page";
import POS from "components/POS";
import Invoicing from "components/Invoicing";
import Forms from "components/Forms";
import { Tenant } from "utils/tenants";

function Home(props) {
    const { allowedModules, setConfigurations, api } = useContext(AppContext);
    const { user } = useSelector((state) => state.Login);

    useEffect(() => {
        if (!user) return;
        api.Settings.Configurations.getAll({
            onSuccess: (response) => {
                setConfigurations(response);
            },
            onError: (error) => {
                console.error(error);
            },
        });
    }, [user, api.Settings.Configurations, setConfigurations]);

    return (
        <Suspense fallback={<LoadingPage />}>
            <Menu {...props}>
                <Switch>
                    <Route exact path="/" component={HomePage} />
                    <Route exact path="/open-task/:id" component={HomePage} />
                    {allowedModules &&
                        allowedModules
                            .filter((x) => x.path && x.dbName && x.formName)
                            .map(({ code, path, dbName, formName, name }) => (
                                <SecureRoute
                                    key={`module-${code}`}
                                    path={path}
                                    render={(props) => <Module {...props} dbName={dbName} formName={formName} code={code} name={name} />}
                                />
                            ))}
                    <SecureRoute exact path="/chat" component={ChatPage} />
                    <SecureRoute exact path="/calendar" component={Calendar} />
                    <SecureRoute path="/customers" component={Customers} />
                    {Tenant.getFeatures().visitors.enabled && <SecureRoute path="/visitors" component={Visitors} />}
                    <SecureRoute path="/settings" component={Settings} />
                    {user.canUsePos && <SecureRoute path="/pos" component={POS} />}
                    {user.canUseInvoicing && <SecureRoute path="/invoicing" component={Invoicing} />}
                    {Tenant.getFeatures().forms.enabled && <SecureRoute path="/forms" component={Forms} />}
                    <Route exact path="/unauthorized" component={NotAuthorized} />
                    {allowedModules && <Route component={NotFound} />}
                </Switch>
            </Menu>
        </Suspense>
    );
}

export default withRouter(Home);
